import api from '@/services/api'
const url = action => `/insurancecompanyinformations/${action}`

export async function postFindInsuranceCompanyInformation(insurance_company_id, page, itemsPerPage){
    var requestBody = {
        query_data: {
            type: "query",
            query_options: [
                { 
                    queryField: "insurance_company_id",
                    queryType: "=",
                    queryData: insurance_company_id
                }
            ],
            pagination: {
                itemsPerPage: itemsPerPage
            }
        }
    }
    const { data: res } = await api.post(url('findByCondition?page=' + page),requestBody) //把response.data 的值傳給res
    return res
}

export async function postCreateInsuranceCompanyInformation(params){
    const { data: res } = await api.post('/insurancecompanyinformations', params) 
    return res
}

export async function putInsuranceCompanyInformation(id, params){
    const { data: res } = await api.put(url(id), params) 
    return res
}

export async function deleteInsuranceCompanyInformation(id){
    const { data: res } = await api.delete(url(id)) 
    return res
}

export async function postUploadNewInsuranceCompanyInformationFile(_insurance_company_id, _title, _description, _publish_date, _file){
    let formData = new FormData()
    formData.append("UploadFile", _file)
    formData.append("insurance_company_id", _insurance_company_id)
    formData.append("title", _title)
    formData.append("description", _description)
    formData.append("publish_date", _publish_date)

    const {data: res} = await api.post(url('postFile'), formData) 

    return res
}

export async function postUploadExistInsuranceCompanyInformationFile(_id, _insurance_company_id, _title, _description, _publish_date, _file){
    let formData = new FormData()
    formData.append("id", _id)
    formData.append("UploadFile", _file)
    formData.append("insurance_company_id", _insurance_company_id)
    formData.append("title", _title)
    formData.append("description", _description)
    formData.append("publish_date", _publish_date)

    const {data: res} = await api.post(url('postFile'), formData) 

    return res
}